import { useQuery } from "@tanstack/react-query";
import { getApiConfig, ABOUT_VIDEO_IDS } from "../_constants/about-constants";

export interface VideoData {
  id: string;
  title: string;
  description: string;
  channelTitle: string;
  channelId: string;
  thumbnail: string;
}

export const useAboutVideos = () => {
  return useQuery({
    queryKey: ["about-videos"],
    queryFn: async (): Promise<VideoData[]> => {
      const config = getApiConfig();
      const response = await fetch(
        `${config.YOUTUBE_DATA_API_PREFIX}/videos?part=snippet&id=${ABOUT_VIDEO_IDS.join(",")}&key=${config.YOUTUBE_API_KEY}`,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch videos");
      }

      const data = await response.json();
      return data.items.map((item: any) => ({
        id: item.id,
        title: item.snippet.title,
        description: item.snippet.description,
        channelTitle: item.snippet.channelTitle,
        channelId: item.snippet.channelId,
        thumbnail: item.snippet.thumbnails.high.url,
      }));
    },
  });
};
